import { useTranslation } from 'react-i18next';
import { LiveChatFlow, useOpenLiveChat } from '@hub/hooks';
import { Button, ButtonProps, TextComponent } from '@monorepo/react-components';

export const ContactSupportButton = ({
  isLoading,
  type = 'link',
  flow,
}: {
  isLoading: boolean;
  flow: LiveChatFlow;
  type?: Extract<ButtonProps['type'], 'link' | 'primary'>;
}) => {
  const { t } = useTranslation(['mailConfirmation']);

  const handleOpenLiveChat = useOpenLiveChat({
    flow,
  });

  return (
    <Button onClick={handleOpenLiveChat} type={type} disabled={isLoading}>
      <TextComponent underline={type === 'link'}>
        {t('mailConfirmation:contact_support')}
      </TextComponent>
    </Button>
  );
};
